import React, { Component } from 'react';
import { connect } from 'react-redux';
import PrintersCard from '../components/printers-card';
import CurrentStatusSection from '../containers/current_status_section';
import LoadingAnimation from '../components/loading-animation';
import {bindActionCreators} from "redux";
import {startFetchingMaterialUsageOfPrinter, startFetchingPrintsNumber} from "../actions/getPrinterStatistics";

class PrintersPanel extends Component {
  componentWillReceiveProps(nextProps) {
    const prevPrinterIds = this.props.printerStatus.printerIds;
    const nextPrinterIds = nextProps.printerStatus.printerIds;
    if (prevPrinterIds.length === 0 && nextPrinterIds.length !== 0) {
      this.fetchStatistics(nextPrinterIds);
    }
  }

  render() {
    if (this.props.printerStatus.printerIds.length === 0) {
      return <div style={{padding:'15px'}}>No printer found</div>
    }
    return <div>
      { this.printerCards() }
      <div style={{display: 'none'}}><CurrentStatusSection/></div>
      </div>
  }

  componentDidMount() {
    const { printerIds } = this.props.printerStatus;
    if (printerIds.length !== 0) {
      this.fetchStatistics(printerIds);
    }
  }

  fetchStatistics(printerIds) {
    printerIds.forEach(printerId => {
      this.props.startFetchingMaterialUsageOfPrinter(printerId);
      this.props.startFetchingPrintsNumber(printerId)
    });
  }

  printerCards() {
    const printerCardsList = [];
    this.props.printerStatus.printerIds.forEach((printerId, index) => {
      printerCardsList.push(this.composePrinterCard(printerId, index));
    })
    return printerCardsList;
  }

  composePrinterCard(printerId, index) {
    const printerState = this.props.printerStatus[printerId];
    const receivedStatistics = this.props.printerStatistics[printerId];
    return <PrintersCard
        key={ index }
        printerState={ printerState }
        printerId={ printerId }
        userId={ this.props.userId }
        materialUsage={receivedStatistics ? receivedStatistics.materialUsage : {}}
        printsNumber={receivedStatistics ? receivedStatistics.printsNumber : 0}
      />
  }
}

const mapStateToProps = state => ({
  printerStatus: state.printerStatus,
  printerStatistics: state.printerStatistics,
  userId: state.userProfile.profile.sub
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    startFetchingMaterialUsageOfPrinter,
    startFetchingPrintsNumber
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintersPanel);


// WEBPACK FOOTER //
// ./src/containers/printers_panel.js